export default __webpack_public_path__ + "static/media/partner-5-puzzle-royale.e742f1d6.png";